import Refresh from "@mui/icons-material/Refresh";
import { IconButton, LinearProgress } from "@mui/material";
import { Permissions } from "app/constants";
import { ButtonGroup, PageHeader, Toolbar } from "common";
import useAccess from "features/profile/useAccess";
import useSettings from "features/settings/useSettings";
import useHeaderHeight from "helpers/useHeaderHeight";
import { useSalesReportDataContext } from "./useSalesReportData";

export interface SalesReportHeaderProps {}

const SalesReportHeader: React.FC<SalesReportHeaderProps> = ({}) => {
  const { load, loading } = useSalesReportDataContext();
  const { hasPermissions } = useAccess();
  const [settings, setSettings] = useSettings({ key: "salesReport" });
  const headerHeight = useHeaderHeight();
  return (
    <>
      <PageHeader title="Sales riport">
        <Toolbar sx={{ gap: 2 }}>
          {hasPermissions(Permissions.ReportPrices) && (
            <ButtonGroup
              size="small"
              options={[
                { value: undefined, label: "EUR" },
                { value: "HUF", label: "HUF" },
                // { value: "USD", label: "USD" },
              ]}
              value={settings.currency}
              onChange={(evt: any) => {
                setSettings({
                  currency: evt.target.value,
                });
              }}
            />
          )}
          <IconButton
            onClick={() => {
              load();
            }}
          >
            <Refresh />
          </IconButton>
        </Toolbar>
      </PageHeader>
      {loading && (
        <LinearProgress
          sx={{ position: "fixed", left: 0, top: headerHeight, right: 0 }}
        />
      )}
    </>
  );
};
export default SalesReportHeader;
